import { formatBirthDateInverse, toISOString } from '../../utils/utils'
import {
  CHANGE_EMAIL_CONTACT,
  CLEAR_LECTURE,
  CLEAR_SEARCH,
  COMPLETE_DOCUMENT,
  COMPLETE_INPUT,
  NEW_PROCEDURE_DATE,
  NEW_PROSPECTO_COMPLETED,
  OBD_RESPONSE,
  PROCEDURE_COMPLETED,
  SAVE_CLIENT_PIN,
  SAVE_CLIENT_SIGN,
  SAVE_DOCUMENT_ID,
  SAVE_IMG_RECOGNITION_RESPONSE,
  SAVE_LINE_NUMBER,
  SAVE_LINE_VALIDATION_RESPONSE,
  SAVE_PHOTO,
  SAVE_PHOTO_BACK,
  SAVE_PHOTO_FRONT,
  SAVE_PORTABILIDAD_ID,
  SAVE_PROSPECTOS,
  SAVE_SCANNED_CI,
  SAVE_SCANNED_DOCUMENT,
  SAVE_TRAMITES,
  SET_VALIDATION_TYPE,
  SIM_DATA,
  STORE_PROCEDURE
} from '../actions'

interface ActionObject {
  type: string
  payload: any
}

const emptyProspectoForm = {
  nombre: '',
  apellido: '',
  negocio: '',
  telefono: '',
  email: ''
}

const emptyLineForm = {
  lineNumber: '',
  serviceType: '',
  email: '',
  cardNumber: '',
  chipNumber: ''
}

const emptyLinePYForm = {
  lineNumber: '',
  serviceType: '',
  emailOptional: '',
  cardNumber: '',
  posNumberProcedure: ''
}

const emptyIdForm = {
  documentNumber: '',
  names: '',
  lastName: '',
  nationality: '',
  birthDate: '',
  sex: ''
}

const emptyIdNomForm = {
  passport: '',
  names: '',
  lastName: '',
  nationality: '',
  birthDate: '',
  sex: '',
  limitDate: ''
}

const emptyAddressForm = {
  geuDescription: '',
  accAddressCity: '',
  addressStreet: '',
  addressNumber: ''
}

const emptyIdPrepagaForm = {
  documentType: '',
  documentNumber: '',
  names: '',
  lastName: '',
  nationality: '',
  birthDate: '',
  securityCode: ''
}

const emptyChipForm = {
  cardNumber: '',
  posNumberProcedure: ''
}

const emptyPreOBDForm = {
  documentType: '',
  documentNumber: ''
}

const emptyNomLineForm = {
  emailOptional: '',
  lineNumber: ''
}

const initialState = {
  allProspectos: [],
  storedProspecto: {},
  allTramites: [],
  nuevoProspectoForm: emptyProspectoForm,
  idPortabilidad: '',
  lineValidationForm: emptyLineForm,
  nomLineForm: emptyNomLineForm,
  lineValidationPYForm: emptyLinePYForm,
  idValidationForm: emptyIdForm,
  chipValidationForm: emptyChipForm,
  preOBDForm: emptyPreOBDForm,
  idPrepagaForm: emptyIdPrepagaForm,
  idNominativityForm: emptyIdNomForm,
  addressForm: emptyAddressForm,
  OBDResponse: {},
  simData: {},
  isClt: false,
  photoFront: '',
  photoBack: '',
  photoClient: '',
  clientPin: '',
  clientSign: '',
  lineValidationResponse: '',
  imgRecognitionResponse: '',
  documentId: '',
  activatedLineNumber: '',
  initializedDate: '',
  storedProcedure: {}
}

export default function rootReducer(state: any = initialState, action: ActionObject) {
  switch (action.type) {
    case SAVE_PROSPECTOS:
      return {
        ...state,
        allProspectos: action.payload
      }
    case STORE_PROCEDURE:
      return {
        ...state,
        storedProcedure: action.payload
      }
    case SAVE_TRAMITES:
      return {
        ...state,
        allTramites: action.payload
      }
    case COMPLETE_INPUT:
      return {
        ...state,
        [action.payload.storeForm]: {
          ...state[action.payload.storeForm],
          [action.payload.name]: action.payload.value
        }
      }
    case OBD_RESPONSE: {
      return {
        ...state,
        OBDResponse: action.payload
      }
    }
    case SIM_DATA: {
      return {
        ...state,
        simData: action.payload
      }
    }
    case NEW_PROSPECTO_COMPLETED:
      return {
        ...state,
        nuevoProspectoForm: emptyProspectoForm
      }
    case PROCEDURE_COMPLETED:
      return {
        ...state,
        nuevoProspectoForm: emptyProspectoForm,
        idPortabilidad: '',
        lineValidationForm: emptyLineForm,
        lineValidationPYForm: emptyLinePYForm,
        nomLineForm: emptyNomLineForm,
        idValidationForm: emptyIdForm,
        chipValidationForm: emptyChipForm,
        preOBDForm: emptyPreOBDForm,
        idPrepagaForm: emptyIdPrepagaForm,
        idNominativityForm: emptyIdNomForm,
        addressForm: emptyAddressForm,
        OBDResponse: {},
        simData: {},
        isClt: false,
        photoFront: '',
        photoBack: '',
        photoClient: '',
        clientPin: '',
        clientSign: '',
        lineValidationResponse: '',
        imgRecognitionResponse: '',
        documentId: '',
        activatedLineNumber: '',
        initializedDate: '',
        storedProcedure: {}
      }
    case CHANGE_EMAIL_CONTACT:
      return {
        ...state,
        [action.payload.form]: {
          ...state[action.payload.form],
          [action.payload.label]: action.payload.email
        }
      }
    case SAVE_PHOTO_FRONT:
      return {
        ...state,
        photoFront: action.payload
      }
    case SAVE_PHOTO_BACK:
      return {
        ...state,
        photoBack: action.payload
      }
    case SAVE_PHOTO:
      return {
        ...state,
        photoClient: action.payload
      }
    case SAVE_SCANNED_DOCUMENT:
      return {
        ...state,
        idValidationForm: action.payload
      }
    case SAVE_CLIENT_PIN:
      return {
        ...state,
        clientPin: action.payload
      }
    case SAVE_CLIENT_SIGN:
      return {
        ...state,
        clientSign: action.payload
      }
    case SAVE_PORTABILIDAD_ID:
      return {
        ...state,
        idPortabilidad: action.payload.id,
        lineValidationForm: {
          ...state.lineValidationForm,
          lineNumber: action.payload.line
        },
        lineValidationPYForm: {
          ...state.lineValidationPYForm,
          lineNumber: action.payload.line
        },
        idValidationForm: {
          ...state.idValidationForm,
          documentNumber: action.payload.documentNumber,
          documentType: action.payload.documentType
        }
      }
    case SAVE_DOCUMENT_ID:
      return {
        ...state,
        documentId: action.payload
      }
    case SAVE_LINE_VALIDATION_RESPONSE:
      return {
        ...state,
        lineValidationResponse: action.payload
      }
    case SAVE_IMG_RECOGNITION_RESPONSE:
      return {
        ...state,
        imgRecognitionResponse: action.payload
      }
    case COMPLETE_DOCUMENT:
      return {
        ...state,
        idValidationForm: {
          ...state.idValidationForm,
          documentNumber: action.payload.documentNumber,
          names: action.payload.names,
          lastName: action.payload.lastName,
          nationality: 'AR',
          birthDate: action.payload.birthDate,
          sex: action.payload.sex
        }
      }
    case SET_VALIDATION_TYPE:
      return {
        ...state,
        [action.payload.form]: {
          ...state[action.payload.form],
          validationType: action.payload.type
        }
      }
    case SAVE_SCANNED_CI:
      return {
        ...state,
        idPrepagaForm: {
          documentType: 'CI',
          documentNumber: action.payload.documentNumber,
          names: action.payload.names,
          lastName: action.payload.lastNames,
          nationality: 'PY',
          gender: action.payload.gender,
          birthDate: formatBirthDateInverse(action.payload?.birthDate),
          securityCode: action.payload.verificaterDigit,
          validationType: 'ESCANEO'
        }
      }
    case CLEAR_LECTURE:
      return {
        ...state,
        idPrepagaForm: emptyIdPrepagaForm,
        photoFront: '',
        photoBack: '',
        imgRecognitionResponse: ''
      }
    case SAVE_LINE_NUMBER:
      return {
        ...state,
        activatedLineNumber: action.payload
      }
    case NEW_PROCEDURE_DATE:
      if (action.payload.length)
        return {
          ...state,
          initializedDate: action.payload
        }
      else
        return {
          ...state,
          initializedDate: toISOString(new Date())
        }
    case CLEAR_SEARCH:
      return {
        ...state,
        idNominativityForm: {
          ...state.idNominativityForm,
          names: '',
          lastName: '',
          birthDate: '',
          sex: ''
        }
      }
    default:
      return state
  }
}
